// @ts-strict-ignore
import {
    UpdateUserDevicesSuccessAction,
    UpdateShouldShowSimplifiedBdUISuccessAction,
    UpdateTimezonePreferenceSuccessAction,
    UpdateTriageStateSortOrderSuccessAction,
} from './../actions/user';
import { LogoutSuccessAction, LOGOUT_SUCCESS } from '../actions/login';
import { ClearStateAction, CLEAR_STATE, FetchStateSuccessAction, FETCH_STATE_SUCCESS } from '../actions/state';
import { NewPasswordSuccessAction } from '../actions/user';
import { User } from '../types';
import { UserUpdatable } from '@/actions/updatable';

type UserActionTypes =
    | FetchStateSuccessAction
    | NewPasswordSuccessAction
    | LogoutSuccessAction
    | ClearStateAction
    | UpdateUserDevicesSuccessAction
    | UpdateShouldShowSimplifiedBdUISuccessAction
    | UpdateTimezonePreferenceSuccessAction
    | UpdateTriageStateSortOrderSuccessAction;

export default function user(state: User = null, action: UserActionTypes): User {
    switch (action.type) {
        case FETCH_STATE_SUCCESS:
            if (action.payload.user) {
                return {
                    ...state,
                    ...action.payload.user,
                };
            }
            return state;
        case UserUpdatable.UPDATE_USER_DEVICES_SUCCESS: {
            const newUser = action.payload;
            return {
                ...state,
                ...newUser,
            };
        }
        case UserUpdatable.NEW_PASSWORD_SUCCESS:
            return {
                ...state,
                needsNewPassword: action.payload.needsNewPassword,
            };
        case UserUpdatable.UPDATE_SHOW_SIMPLIFIED_BD_UI_SUCCESS:
            return {
                ...state,
                shouldShowSimplifiedBuildDistributionUI: action.payload.shouldShowSimplifiedBuildDistributionUI,
            };
        case UserUpdatable.UPDATE_TIMEZONE_PREFERENCE_SUCCESS:
            return {
                ...state,
                timezonePreference: action.payload.timezonePreference,
            };
        case UserUpdatable.UPDATE_TRIAGE_STATE_SORT_ORDER_SUCCESS:
            return {
                ...state,
                triageStateSortOrder: action.payload.triageStateSortOrder,
            };
        case CLEAR_STATE:
        case LOGOUT_SUCCESS:
            return null;
        default:
            return state;
    }
}
